import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import {
  checkUserByPhone,
  confirmUser,
  addContactUser
} from '../../actions/users'
import update from 'immutability-helper'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import { openSnackBar } from '../../actions/snack-bar'
import { TextMaskCustom } from '../MaskedInput'
import { Typography } from '@material-ui/core'

class FormDialog extends React.Component {
  state = {
    open: false,
    user: {
      first_name: '',
      last_name: '',
      phone: '',
      title: '',
      delay: '45',
      role: ''
    },
    foundUser: {
      first_name: '',
      last_name: '',
      phone: '',
      title: '',
      delay: '',
      role: ''
    },
    stepper: 0,
    isUserFound: false,
    isEditingUser: false
  }

  componentDidMount() {
    this.clearForms()
  }

  clearForms() {
    this.setState({
      open: false,
      user: {
        first_name: '',
        last_name: '',
        phone: '',
        title: '',
        delay: '45',
        role: ''
      },
      foundUser: {
        first_name: '',
        last_name: '',
        phone: '',
        title: '',
        delay: '',
        role: ''
      },
      stepper: 0,
      isUserFound: false,
      isEditingUser: false
    })
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  handleInputChange = e => {
    const fieldName = e.target.name
    let value = e.target.value
    if (value !== ' ') {
      let newState = update(this.state, {
        user: {
          [fieldName]: { $set: value }
        }
      })
      this.setState(newState)
    }
  }

  handleInputChangeNumber = e => {
    const fieldName = e.target.name
    let value = e.target.value.replace(/\D/, '')

    let newState = update(this.state, {
      user: {
        [fieldName]: { $set: value }
      }
    })
    this.setState(newState)
  }

  handleInputChangeText = e => {
    const fieldName = e.target.name
    let value = e.target.value
    if (value !== ' ') {
      let newState = update(this.state, {
        user: {
          [fieldName]: { $set: value }
        }
      })
      this.setState(newState)
    }
  }

  doCheck = () => {
    this.setState({
      checkingNumber: true
    })
    let phone = this.state.user.phone.replace(/\D/g, '')
    this.props
      .dispatch(checkUserByPhone(phone))
      .then(res => {
        this.setState({ foundUser: res, title: '', delay: '' })
        this.setState({ stepper: this.state.stepper + 1 })
        this.setState({ isUserFound: true })
        this.setState({ user: { ...res, title: '', delay: '45' } })
      })
      .catch(err => {
        if (err.status === 404) {
          // this.createUser();
          // openSnackBar({
          //   message: 'There number was not found'
          // })
          this.setState({ stepper: this.state.stepper + 1 })
          this.setState({
            checkingNumber: false
          })
          this.setState({ isUserFound: false })
        }
      })
  }

  updateContact = newID => {
    this.props
      .dispatch(
        confirmUser({
          contacts_id: newID ? newID : this.state.foundUser.id,
          contacts_glue_id: this.state.foundUser.glue_id,
          title: this.state.user.title,
          delay: this.state.user.delay,
          isEditingUser: this.state.isEditingUser
        })
      )
      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "Problem in updating this contact"
          })
        );
      });

    this.setState({
      stepper: 0
    })
    this.clearForms()
    this.props.dispatch({
      type: 'USER::EDIT_SAFETY_CONTACT',
      payload: { open: false }
    })
    // doRefresh()
    // }
  }

  createContact = () => {
    if (this.state.user.first_name && this.state.user.last_name) {
      this.props
      .dispatch(addContactUser(this.state.user))
      .then(res => {
        this.setState({
          foundUser: {
            id: res.id
          }
        })
        return res
      })
      .then(res => this.updateContact(res.id))

      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "Problem in adding this contact"
          })
        );
        console.log(err)
      });
    } else {
      this.props.dispatch(
        openSnackBar({
          message: "Please enter the empty value"
        })
      );
    }
  }

  handleCancel = () => {
    this.props.dispatch({
      type: 'USER::EDIT_SAFETY_CONTACT',
      payload: { open: false }
    })
    this.setState(() => ({
      stepper: 0,
      foundUser: {
        first_name: '',
        last_name: '',
        phone: '',
        title: '',
        delay: '',
        role: 'contact'
      },
      user: {
        first_name: '',
        last_name: '',
        phone: '',
        title: '',
        delay: '',
        role: 'contact'
      }
    }))
  }

  componentDidUpdate() {
    // This only runs when editing an existing contact
    if (
      this.state.stepper === 0 &&
      this.props.data &&
      this.props.data.phone &&
      !this.state.user.phone
    ) {
      const user = this.state.user
      const foundUser = this.state.foundUser
      user.phone = this.props.data.phone
      user.title = this.props.data.title
      user.delay = this.props.data.delay
      user.glue_id = this.props.data.glue_id
      foundUser.first_name = this.props.data.first_name
      foundUser.phone = this.props.data.phone
      foundUser.glue_id = this.props.data.glue_id
      foundUser.title = this.props.data.title
      foundUser.delay = this.props.data.delay
      foundUser.id = this.props.data.id
      foundUser.last_name = this.props.data.last_name

      this.setState({
        user,
        stepper: 1,
        isUserFound: true,
        foundUser,
        isEditingUser: true
      })
    }
  }

  render() {
    const { open, classes } = this.props
    const { isUserFound } = this.state

    return (
      <Dialog
        open={open}
        // style={{ width }}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" className={classes.headerText}>
          {this.state.stepper === 0 && `Add an Emergency Contact         `}
          {this.state.stepper === 1 && this.state.isUserFound && (
            <span style={{ fontSize: 18, lineHeight: 1 }}>
              We found <br /> <b>{this.state.foundUser.first_name}</b>
              <b> {this.state.foundUser.last_name}</b>, <br />{' '}
              <small>would you like to add them?</small>
            </span>
          )}
          {this.state.stepper === 1 && this.state.isUserFound === false && (
            <span>Add a contact</span>
          )}
        </DialogTitle>

        <DialogContent>
          {this.state.stepper === 0 && (
            <TextField
              autoFocus
              value={this.state.user.phone}
              onChange={this.handleInputChange}
              margin="normal"
              type="tel"
              id="phone"
              name="phone"
              label="Mobile Phone"
              fullWidth
              autoComplete="off"
              InputProps={{
                inputComponent: TextMaskCustom
              }}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  if (this.state.stepper === 0) {
                    this.doCheck()
                  } else {
                    this.updateContact()
                  }
                }
              }}
            />
          )}
          {this.state.stepper === 1 && (
            <>
              {!isUserFound && (
                <Fragment>
                  <TextField
                    value={this.state.user.phone}
                    onChange={this.handleInputChange}
                    margin="dense"
                    disabled
                    id="phone"
                    name="phone"
                    type="tel"
                    label="Mobile Phone"
                    fullWidth
                    autoComplete="none"
                  />
                  <TextField
                    autoFocus={!isUserFound}
                    value={this.state.user.first_name}
                    disabled={isUserFound}
                    onChange={this.handleInputChangeText}
                    margin="dense"
                    id="firstName"
                    name="first_name"
                    label="First Name"
                    fullWidth
                    // InputProps={{ inputComponent: MaskText }}
                    autoComplete="none"
                    type="text"
                  />
                  <TextField
                    value={this.state.user.last_name}
                    disabled={isUserFound}
                    onChange={this.handleInputChangeText}
                    margin="dense"
                    id="lastName"
                    name="last_name"
                    label="Last Name"
                    fullWidth
                    autoComplete="none"
                  />
                </Fragment>
              )}
              <TextField
                autoFocus={isUserFound}
                margin="dense"
                id="title"
                name="title"
                value={this.state.user.title}
                onChange={this.handleInputChange}
                label="Relationship to Contact"
                fullWidth
              />
              <Typography style={{ marginTop: '20px', fontSize: 13 }}>
                {this.state.foundUser.first_name}{' '}
                {this.state.foundUser.last_name} will be notified if you don't
                end a showing. <br />
                <br /> Once a showing starts, how long should we wait before
                notifying them?
              </Typography>
              <TextField
                margin="dense"
                id="delay"
                name="delay"
                type="tel"
                value={this.state.user.delay}
                onChange={this.handleInputChangeNumber}
                label="Minutes"
                fullWidth
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    if (this.state.stepper === 0) {
                      this.doCheck()
                    } else {
                      this.updateContact()
                    }
                  }
                }}
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.handleCancel()} color="primary">
            Cancel
          </Button>

          <Button
            onClick={() => {
              if (this.state.stepper === 0) {
                this.doCheck()
              } else if (this.state.isUserFound) {
                this.updateContact()
              } else {
                this.createContact()
              }
            }}
            variant="contained"
            color="primary"
            disabled={
              (this.state.stepper === 0
                ? !(this.state.user.phone.length === 14)
                : false) || this.state.stepper === 1
                ? !(this.state.user.title && this.state.user.delay > 0)
                : false
            } // cannot input short number
          >
            {this.state.stepper === 0 && `NEXT`}
            {this.state.stepper === 1 && `CONFIRM`}
            {/* {this.state.stepper === 1 && `SAVE`} */}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.safetyContacts.open,
    data: state.safetyContacts.data
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(FormDialog))
